// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Invitations-AcceptInvitation-module__container";
var _2 = "webpack-containers-Invitations-AcceptInvitation-module__time";
export { _1 as "container", _2 as "time" }
